import React from "react"
import { makeStyles } from "@material-ui/core"
import { Typography } from "@material-ui/core/index"
import { injectIntl } from "gatsby-plugin-intl"

const useStyles = makeStyles((theme) => ({
  missionContainer: {
    backgroundColor: "#221a14",
    padding: theme.spacing(10, 4),
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(7, 2.5),
    },
  },
  missionInner: {
    maxWidth: 1280,
    margin: "0 auto",
  },
  missionHeader: {
    color: "#fff",
    fontWeight: 300,
    fontSize: "2.3rem",
    lineHeight: 1.15,
    marginBottom: theme.spacing(3),
    ["@media (max-width:600px)"]: {
      fontSize: "1.9rem",
    },
  },
  missionText: {
    color: "#e6dccf",
    fontSize: "1.15rem",
    lineHeight: 1.7,
    fontWeight: 300,
    maxWidth: 760,
    whiteSpace: "pre-line",
  },
}))

const Mission = ({ intl }) => {
  const classes = useStyles()
  return (
    <section className={classes.missionContainer}>
      <div className={classes.missionInner}>
        <Typography component="h2" className={classes.missionHeader}>
          {intl.formatMessage({ id: "mission.title" })}
        </Typography>
        <Typography component="p" className={classes.missionText}>
          {intl.formatMessage({ id: "mission.description" })}
        </Typography>
      </div>
    </section>
  )
}

export default injectIntl(Mission)
